import { bake_cookie,read_cookie } from 'sfcookies';

import { RECORD_LAP,DEL_LAP,CLEAR_ALL_LAP } from '../constants';


const add = (lap) => {
    return {
        id: Math.floor(Math.random()*100),
        lap
    }
}
const del = (id,state) => {
    let res = state.filter(lap=>lap.id!==id);
    return res;
}
const laps = (state=[],action) => {
    let laps = null;
    state = read_cookie('laps');
    switch (action.type) {
        case RECORD_LAP:
            laps=[...state,add(action.lap)];
            //console.log('laps as state after add',laps);
            bake_cookie('laps',laps);
            return laps;
        
        case DEL_LAP:
            laps=del(action.id,state);
            //console.log('laps as state after del',laps);
            bake_cookie('laps',laps);
            return laps;
        
        case CLEAR_ALL_LAP:
            laps=[];
            bake_cookie('laps',laps);
            return laps;
    
        default:
            return state;
    }

}

export default laps;


// WEBPACK FOOTER //
// ./src/reducers/stopwatchReducer.js